export function Alert({ message }) {
  if (!message) return null

  // This element is present on the index.html
  $('.save-content')
    .fadeIn(500)
    .removeClass('alert-danger alert-warning')
    .addClass('alert-success')
    .html(message)
    .fadeOut(10000)
}
